import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";

import App from "./App";
import { LanguageProvider } from "./context/LanguageContext";
import { ThemeProvider } from "./context/ThemeContext";
import { NotificationProvider } from "./context/NotificationContext";
import { InAppNotificationProvider } from "./context/InAppNotificationContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <ThemeProvider>
      <NotificationProvider>
        <LanguageProvider>
          <InAppNotificationProvider>
            <App />
          </InAppNotificationProvider>
        </LanguageProvider>
      </NotificationProvider>
    </ThemeProvider>
  </BrowserRouter>
);
